import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Routes } from "../../common/Routes";
import { inProgress } from "../../common/utils";
import { IsFeatureEnabledOrNot } from "../../FeatureToggles/FeatureEnabledOrNot";
import { ToggleList } from "../../FeatureToggles/toggleList";
import { AppSideBarPageActions } from "../../parts/AppSideBar/model";

export const UserGroupsController = (userGroupTypeUniqueName) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const featureToggleProgress = useSelector(
    (rootState) => rootState.featureToggleList.featureToggleList.progress,
  );
  const isUserGroupFeatureEnabled = IsFeatureEnabledOrNot(ToggleList.UserGroups);

  useEffect(() => {
    if (!isUserGroupFeatureEnabled && !inProgress(featureToggleProgress)) {
      history.push(Routes.Applications.path);
    }
  }, [isUserGroupFeatureEnabled, featureToggleProgress]);

  useEffect(() => {
    dispatch(AppSideBarPageActions.updateSelectedSideBar(userGroupTypeUniqueName));
  }, []);

  return { isUserGroupFeatureEnabled };
};
